// extracted by mini-css-extract-plugin
export default {"card":"G3-z"};